import { useContext, useSyncExternalStore } from "react";
import { desktopBridge } from "../../lib/desktop";
import { WorkspacePaneWidthContext } from "../../lib/workspace-local-state";

const compactQuery = "(max-width: 767px)";
const touchQuery = "(hover: none) and (pointer: coarse)";
function subscribe(callback: () => void) {
  const queries = [compactQuery, touchQuery].map((query) => window.matchMedia(query));
  for (const query of queries) query.addEventListener("change", callback);
  return () => {
    for (const query of queries) query.removeEventListener("change", callback);
  };
}
function snapshot() {
  if (!window.matchMedia(compactQuery).matches) return "wide";
  return !desktopBridge() && window.matchMedia(touchQuery).matches ? "phone" : "compact";
}
function subscribeViewportWidth(callback: () => void) {
  window.addEventListener("resize", callback);
  return () => window.removeEventListener("resize", callback);
}
function viewportWidth() {
  return window.innerWidth;
}
/** The width the conversation actually has: its workspace pane, or the whole window. */
export function useChatWidth() {
  const pane = useContext(WorkspacePaneWidthContext);
  const viewport = useSyncExternalStore(
    subscribeViewportWidth,
    viewportWidth,
    () => Number.POSITIVE_INFINITY,
  );
  return pane ?? viewport;
}
/** A narrow desktop keeps its bot rail; only touch phones use a navigation drawer. */
export function useChatLayout() {
  const width = useContext(WorkspacePaneWidthContext);
  const viewport = useSyncExternalStore(subscribe, snapshot, () => "wide");
  if (width === null) return viewport;
  if (width > 767) return "wide";
  return !desktopBridge() && window.matchMedia(touchQuery).matches ? "phone" : "compact";
}
